import { createBrowserRouter } from "react-router-dom";
import { lazy, Suspense, type ComponentType } from "react";
import withRouteProtected from "./PrivateRoute";
import { RoutePaths } from "./routes.contants";

const Home = lazy(() => import("../../dashboard/views"));
const Logs = lazy(() => import("../../repurchase/logs/pages/Logs"));
const Recompra = lazy(() => import("../../repurchase/channels/views/Channels"));
const FormRecompra = lazy(() => import("../../repurchase/channels/views/form"));
const Frecuencias = lazy(
  () => import("../../repurchase/frequencies/pages/Frecuencies")
);
const Login = lazy(() => import("../../authentication/views/loginPage"));
const ChannelsFormView = lazy(
  () => import("@features/business/channels/views/ChannelsFormView")
);
const ChannelsListView = lazy(
  () => import("@features/business/channels/views/ChannelsListView")
);
const ListIntermediariesView = lazy(
  () =>
    import("@features/application/intermediaries/views/ListIntermediariesView")
);
const IntermediaryFormView = lazy(
  () =>
    import("@features/application/intermediaries/views/IntermediaryFormView")
);
const PageNotFound = lazy(() => import("@components/elements/pageNotFound"));

const createRouteElement = <P extends object>(
  Component: ComponentType<P>,
  props: P
) => {
  const ProtectedComponent = withRouteProtected(Component);
  return (
    <Suspense fallback="Loading...">
      <ProtectedComponent {...props} />
    </Suspense>
  );
};

const privateRoutes = [
  { path: RoutePaths.Dashboard, element: Home },
  { path: RoutePaths.RepurchaseChannels, element: Recompra },
  { path: RoutePaths.RepurchaseChannelsCreate, element: FormRecompra },
  { path: RoutePaths.RepurchaseChannelsEdit, element: FormRecompra },
  { path: RoutePaths.RepurchaseFrecuencies, element: Frecuencias },
  { path: RoutePaths.RepurchaseLogs, element: Logs },
  { path: RoutePaths.BusinessChannels, element: ChannelsListView },
  { path: RoutePaths.BusinessChannelsEdit, element: ChannelsFormView },
  { path: RoutePaths.BusinessChannelsCreate, element: ChannelsFormView },
  { path: RoutePaths.ApplicationIntermediaries, element: ListIntermediariesView },
  { path: RoutePaths.ApplicationIntermediariesCreate, element: IntermediaryFormView },
  { path: RoutePaths.ApplicationIntermediariesEdit, element: IntermediaryFormView },
];

const router = createBrowserRouter([
  ...privateRoutes.map(({ path, element }) => ({
    path,
    element: createRouteElement(element, { isPrivate: true }),
  })),
  {
    path: RoutePaths.Login,
    element: createRouteElement(Login, {}),
  },
  {
    path: "*",
    element: createRouteElement(PageNotFound, {}),
  },
]);

export { router };
